import {Component, Inject} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {
  NavController,
  NavParams,
  ToastController,
  ViewController,
} from 'ionic-angular';
import {UserAuthenticationService} from '../../../services/index';
import {EnvVariables} from '../../../../../environment-variables/environment-variables.token';
import {PrismConfigOptions} from '../../../../../environment-variables/environment-variables.interface';

/**
 * sets up the login form and it's validators
 * @class LoginFormComponent
 */
@Component({
  selector: 'advtech-login-form',
  templateUrl: './login-form.component.html',
})
export class LoginFormComponent {
  /**
   * The login form
   * @type {FormGroup}
   */
  loginForm: FormGroup;

  /**
   * Changes the header image based on the configs
   * @type {string}
   */
  loginHeaderImage: string;

  /**
   * Changes the logo class based on the configs
   * @type {{loginLogo: boolean}}
   */
  loginLogoClasses: {} = {loginLogo: true};

  /**
   * Should show the form
   * @type {boolean}
   */
  showForm: boolean = false;

  /**
   * @constructor
   * @param {FormBuilder} formBuilder - Instance of the FormBuilder class
   * @param {NavController} navCtrl - Instance of the NavController class
   * @param {ToastController} toast - Instance of the ToastController class
   * @param {UserAuthenticationService} userAuthService - Instance of the UserAuthenticationService
   * @param {NavParams} navParams - Instance of the NavParams
   * @param {ViewController} viewCtrl - Instance of the ViewController
   * @param {EnvVariables} envVariables = Instance of the EnvVariables
   */
  constructor(public formBuilder: FormBuilder,
              public navCtrl: NavController,
              public toast: ToastController,
              public userAuthService: UserAuthenticationService,
              public navParams: NavParams,
              private viewCtrl: ViewController,
              @Inject(EnvVariables) envVariables: PrismConfigOptions) {
    if (!this.navParams.get('skipLoginCheck')) {
      this.userAuthService.isUserLoggedIn().subscribe((data) => {
        if (data.isLoggedIn) {

          if (!localStorage.getItem('displayName')) {
            this.userAuthService.getUser().subscribe((userData) => {
              localStorage.setItem('displayName', userData.username);
            });
          }

          return this.navCtrl.setRoot('MyRecentListingPage');
        }
        else {
          this.doLoginForm();
        }
      }, (err) => {
        if (err.error === 'AccessDeniedException') {
          this.doLoginForm();
        }
      });
    }
    else {
      this.doLoginForm();
    }

    this.loginForm = formBuilder.group({
      password: [''],
      username: [''],
    });
    this.loginLogoClasses[envVariables.loginLogoClass] = true;
    this.loginHeaderImage = envVariables.loginFormLogo;
  }

  /**
   * Handles the auth check redirects to the listing controller if successful or presents a toast message
   * @returns {void}
   */
  checkAuth(): void {
    const username: string | null = this.loginForm.value.username;
    const password: string | null = this.loginForm.value.password;

    this.userAuthService.authenticateUser(username, password).subscribe((res: any) => {
        if (!res.error) {

          if (!localStorage.getItem('displayName')) {
            this.userAuthService.getUser().subscribe((userData) => {
              localStorage.setItem('displayName', userData.username);
            });
          }

          localStorage.setItem('username', username);
          if (this.navParams.get('modal') === true) {
            return this.viewCtrl.dismiss();
          }
          else {
            return this.navCtrl.setRoot('MyRecentListingPage');
          }
        }
        else {
          return this.toast.create({
            closeButtonText: 'Ok',
            dismissOnPageChange: true,
            message: res.status,
            position: 'bottom',
            showCloseButton: true,
            cssClass: 'wrap-toast',
          }).present();
        }
      },
      (err) => {
        return this.toast.create({
          dismissOnPageChange: true,
          message: err.status || 'An unknown error has occurred',
          position: 'bottom',
          showCloseButton: true,
          cssClass: 'wrap-toast',
        }).present();
      });
  }

  /**
   * Shows the login form and calls login
   * @returns {void}
   */
  doLoginForm(): void {
    this.showForm = true;
    this.userAuthService.login();
  }
}



// WEBPACK FOOTER //
// ./src/app/user/login/components/form/login/login-form.component.ts